import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Droppable } from "react-beautiful-dnd";
import UserCard from './Card';
import { findSg } from '../utils';


const FarmUserList = () => {
    const usersList = useSelector((state) => state.scoutKanban.farmUsersList.payload);
    const isRequestingFarmUsersList = useSelector((state) => state.scoutKanban.farmUsersList.isRequesting);
    const scoutSearchText = useSelector((state) => state.scoutKanban.scoutSearchText);

    const farmUsersList = useMemo(() => {
        if (usersList && usersList.length > 0) {
            const uniqueUsers = usersList.reduce((acc, item) => {
                if (!acc.some(el => el.user_id === item.user_id)) {
                  acc.push(item);
                }
                return acc;
              }, []);          
            return uniqueUsers.filter((usr) => usr.role_id === 3 && usr.email && !usr.email.includes("acuitusag"))
        }
        return usersList;
    }, [usersList])


    return (
        <div className='scout_drag_container'>
            <div className="scout_kanban_header w-100"><i className="icon icon-scout mr-2"></i> Scouts</div>
            <Droppable droppableId="farmusers"/*  isDropDisabled={!isToday(range)} */>
                {(provided, snapshot) => (
                    <div
                        ref={provided.innerRef}
                        className={`kanban-column-body scout-cards`}
                    >
                        {isRequestingFarmUsersList && <div className="mt-4 w-100 text-center">Loading...</div>}
                        {farmUsersList && farmUsersList.length > 0 &&
                            farmUsersList/* .filter((usr) => usr.role_id === 3 && !usr.email.includes("@acuitusag.com")) */.map((user, index) => {
                                return (
                                    <UserCard
                                        key={index}
                                        index={index}
                                        userId={user.user_id}
                                        user={user}
                                        onFilter={e => findSg(e, { searchText: scoutSearchText }, 'user')}
                                    />
                                )
                            })
                        }
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </div>
    )
}

export default FarmUserList